import { render } from "./EfficientMatching.vue?vue&type=template&id=40930058&scoped=true"
import script from "./EfficientMatching.vue?vue&type=script&lang=js"
export * from "./EfficientMatching.vue?vue&type=script&lang=js"

import "./EfficientMatching.vue?vue&type=style&index=0&id=40930058&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40930058"]])

export default __exports__